// Feature flag for the Creative Studio PDP image-set UI rework (POR-13766).
//
// The reworked card/viewer widgets replace the old row-list picker + tile grid.
// Both the new and the legacy widgets ship in the bundle so we can revert
// instantly if needed:
//   - Flip LEGACY_DEFAULT to true to make the old UI the build-time default, OR
//   - Set localStorage['cs_pdp_ui'] = 'legacy' in the browser for a runtime
//     revert with no rebuild (and 'new'/anything else to force the new UI).
//
// Keep this deterministic and side-effect free — it is read during render.

const LEGACY_DEFAULT = false;

export function isLegacyPdpUi() {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const pref = window.localStorage.getItem('cs_pdp_ui');

      if (pref === 'legacy') {
        return true;
      }

      if (pref === 'new') {
        return false;
      }
    }
  } catch (e) {
    // localStorage can throw in private mode / sandboxed frames — fall through.
  }

  return LEGACY_DEFAULT;
}

export default { isLegacyPdpUi };
